import * as React from "react";
import { BaseBlock, BaseBlockOptions, broadcastBlockLoad } from "sb-resp-lib";

import { BaseDict } from "./dict";
import { config } from "./config";
import { RacingRegionSwitcher } from "./RacingRegionSwitcher";
import { RacingRegionSwitcherData } from "./data";

/*
    This structure allows us to use mocks during dev
    but not to include them when we do build:release
*/
import * as MOCKSTYPE from "sb-resp-lib/lib/mocks";
let _: typeof MOCKSTYPE;
let PageMethodsMock;
if (process.env.NODE_ENV === "development") {
    _ = require("sb-resp-lib/lib/mocks");
    PageMethodsMock = _.PageMethodsMock;
}

export class RacingRegionSwitcherRoot extends BaseBlock {
    dataProvider!: RacingRegionSwitcherData;
    options!: BaseBlockOptions;

    // constructor sets defaults
    constructor(
        domId: string,
        options: BaseBlockOptions = {
            dict: BaseDict,
            cms: {},
            navHandler: {},
            dataProvider: {},
            betSlipUtil: {},
            oddsUtil: {},
            facade: {}
        }
    ) {
        super(domId, options);

        if (process.env.NODE_ENV === "development") {

            // setup data mocks for debug build
            this.dataProvider = new RacingRegionSwitcherData(new PageMethodsMock());

            // setup dictionary for debug build
            this.options.dict = BaseDict;

            //export data store to window for debug purposes
            window["RacingRegionSwitcherDATA"] = this.dataProvider;
        }

        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {

            // use pagemethods passed during the construction from the
            // mobile application
            this.dataProvider = new RacingRegionSwitcherData(options.dataProvider);
        }

        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = { ...BaseDict, ...(options.dict || {}) };

        // merge default and CMS options
        this.options.cms = { ...config, ...(options.cms || {}) };
    }

    activate() {
        return super.activate(
            <RacingRegionSwitcher dataProvider={this.dataProvider} dict={this.options.dict} />
        );
    }
}

window["RacingRegionSwitcher"] = RacingRegionSwitcherRoot;
broadcastBlockLoad("RacingRegionSwitcher");